(function () {
  var CART_PATH_RE = /\/cart\/(?:add|change|update)(?:\.js)?/;
  var normalizing = false;
  var pendingTimer = null;
  var openBoxProductIdMap = null;
  var checkoutPending = false;

  function rootPath(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/$/, '') + path;
  }

  function textIncludesOpenBox(value) {
    var text = String(value || '').toLowerCase();
    return text.indexOf('open box') !== -1 ||
      text.indexOf('open-box') !== -1 ||
      text.indexOf('open_box') !== -1 ||
      text.indexOf('openbox') !== -1 ||
      text.indexOf('torn packaging') !== -1 ||
      text.indexOf('packaging imperfections') !== -1 ||
      text.indexOf('opened packaging') !== -1 ||
      text.indexOf('customer-returned') !== -1;
  }

  function itemHasOpenBoxProperty(item) {
    var props = item && item.properties;
    if (!props) return false;
    if (Array.isArray(props)) {
      return props.some(function (prop) {
        return prop && prop.name === '_ck_open_box_limit' && String(prop.value) === 'true';
      });
    }
    return String(props._ck_open_box_limit || '') === 'true';
  }

  function getOpenBoxProductIdMap() {
    if (openBoxProductIdMap) return openBoxProductIdMap;
    openBoxProductIdMap = Object.create(null);
    var node = document.getElementById('ck-open-box-limit-data');
    if (!node) return openBoxProductIdMap;
    try {
      var data = JSON.parse(node.textContent || '{}');
      (data.productIds || []).forEach(function (id) {
        openBoxProductIdMap[String(id)] = true;
      });
    } catch (error) {
      console.warn('Open-box quantity guard could not read collection membership.', error);
    }
    return openBoxProductIdMap;
  }

  function itemHasOpenBoxProductId(item) {
    return Boolean(item && getOpenBoxProductIdMap()[String(item.product_id || '')]);
  }

  function itemHasOpenBoxDomLine(item) {
    var key = String(item && item.key || '');
    if (!key) return false;
    return Array.prototype.some.call(
      document.querySelectorAll('.cart__item[data-ck-open-box-line="true"]'),
      function (line) {
        var input = line.querySelector('[data-id]');
        return String(line.getAttribute('data-key') || '') === key ||
          String(input && input.getAttribute('data-id') || '') === key;
      }
    );
  }

  function itemHasOpenBoxText(item) {
    if (!item) return false;
    return textIncludesOpenBox(item.product_title) ||
      textIncludesOpenBox(item.title) ||
      textIncludesOpenBox(item.handle) ||
      textIncludesOpenBox(item.url);
  }

  function isOpenBoxItem(item) {
    return itemHasOpenBoxProperty(item) ||
      itemHasOpenBoxProductId(item) ||
      itemHasOpenBoxText(item) ||
      itemHasOpenBoxDomLine(item);
  }

  function cartHasOpenBoxExcess(cart) {
    var totals = Object.create(null);
    (cart.items || []).forEach(function (item) {
      if (!isOpenBoxItem(item)) return;
      var productKey = String(item.product_id || item.variant_id || item.key || '');
      totals[productKey] = (totals[productKey] || 0) + Number(item.quantity || 0);
    });
    return Object.keys(totals).some(function (key) {
      return totals[key] > 1;
    });
  }

  function isOpenBoxForm(form) {
    if (!form) return false;
    return Boolean(form.querySelector('[name="properties[_ck_open_box_limit]"][value="true"]'));
  }

  function ensureLimitMessage(input) {
    var line = input && input.closest('.cart__item');
    if (!line || line.querySelector('[data-ck-open-box-limit-message], .cart__item--open-box-limit')) return;
    var wrapper = input.closest('.js-qty__wrapper, quantity-selector, .element-quantity-selector');
    if (!wrapper) return;
    var message = document.createElement('span');
    message.className = 'ck-open-box-limit-message';
    message.setAttribute('data-ck-open-box-limit-message', 'true');
    message.textContent = 'Limit 1 per open-box item.';
    wrapper.insertAdjacentElement('afterend', message);
  }

  function clampInput(input) {
    if (!input) return;
    input.setAttribute('max', '1');
    input.setAttribute('data-ck-open-box-qty', 'true');
    if (String(input.value || '1') !== '1') input.value = '1';
    var wrapper = input.closest('.js-qty__wrapper, quantity-selector, .element-quantity-selector');
    if (wrapper) {
      var plus = wrapper.querySelector('.js-qty__adjust--plus, .element-quantity-selector__button--plus');
      if (plus) {
        plus.setAttribute('disabled', 'disabled');
        plus.setAttribute('aria-disabled', 'true');
      }
    }
    ensureLimitMessage(input);
  }

  function clampOpenBoxForms() {
    document.querySelectorAll('form[action*="/cart/add"], form.product-single__form').forEach(function (form) {
      if (!isOpenBoxForm(form)) return;
      form.querySelectorAll('input[name="quantity"], input.js-qty__num').forEach(clampInput);
    });

    document.querySelectorAll('.cart__item[data-ck-open-box-line="true"] input.js-qty__num').forEach(clampInput);
  }

  function scheduleNormalize() {
    if (pendingTimer) window.clearTimeout(pendingTimer);
    pendingTimer = window.setTimeout(normalizeCart, 350);
  }

  async function normalizeCart() {
    if (normalizing) return false;
    normalizing = true;
    try {
      var response = await window.fetch(rootPath('/cart.js'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return false;
      var cart = await response.json();
      var seenOpenBoxProducts = Object.create(null);
      var openBoxChanges = [];
      (cart.items || []).forEach(function (item) {
        if (!isOpenBoxItem(item)) return;
        var productKey = String(item.product_id || item.variant_id || item.key || '');
        var targetQuantity = seenOpenBoxProducts[productKey] ? 0 : 1;
        seenOpenBoxProducts[productKey] = true;
        if (Number(item.quantity) !== targetQuantity) {
          openBoxChanges.push({ key: item.key, quantity: targetQuantity });
        }
      });

      for (var i = 0; i < openBoxChanges.length; i += 1) {
        var changeResponse = await window.fetch(rootPath('/cart/change.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: openBoxChanges[i].key, quantity: openBoxChanges[i].quantity })
        });
        if (!changeResponse.ok) return false;
      }

      if (openBoxChanges.length) {
        document.dispatchEvent(new CustomEvent('ck:open-box-limit:normalized', {
          detail: { count: openBoxChanges.length }
        }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      var verifyResponse = await window.fetch(rootPath('/cart.js'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!verifyResponse.ok) return false;
      var verifiedCart = await verifyResponse.json();
      return !cartHasOpenBoxExcess(verifiedCart);
    } catch (error) {
      console.warn('Open-box quantity guard could not verify cart quantity.', error);
      return false;
    } finally {
      normalizing = false;
      clampOpenBoxForms();
    }
  }

  function patchFetch() {
    if (window.__ckOpenBoxLimitFetchPatched || !window.fetch) return;
    window.__ckOpenBoxLimitFetchPatched = true;
    var originalFetch = window.fetch.bind(window);

    window.fetch = function () {
      var request = arguments[0];
      var url = typeof request === 'string' ? request : request && request.url;
      var shouldNormalize = url && CART_PATH_RE.test(url);
      return originalFetch.apply(window, arguments).then(function (response) {
        if (shouldNormalize && !normalizing) scheduleNormalize();
        return response;
      });
    };
  }

  function waitForNormalization() {
    return new Promise(function (resolve) {
      function check() {
        if (!normalizing) {
          resolve();
          return;
        }
        window.setTimeout(check, 25);
      }
      check();
    });
  }

  async function normalizeBeforeCheckout(url) {
    if (checkoutPending) return;
    checkoutPending = true;
    if (pendingTimer) {
      window.clearTimeout(pendingTimer);
      pendingTimer = null;
    }
    await waitForNormalization();
    var verified = await normalizeCart();
    await waitForNormalization();
    if (!verified) {
      checkoutPending = false;
      window.alert('We could not confirm the one-item Open Box limit. Please try checkout again.');
      return;
    }
    window.location.assign(url || rootPath('/checkout'));
  }

  function checkoutControlFromEvent(event) {
    return event.target && event.target.closest &&
      event.target.closest('[name="checkout"], a[href*="/checkout"]');
  }

  document.addEventListener('click', function (event) {
    var checkoutControl = checkoutControlFromEvent(event);
    if (!checkoutControl) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    normalizeBeforeCheckout(checkoutControl.tagName === 'A' ? checkoutControl.href : rootPath('/checkout'));
  }, true);

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (!submitter || !submitter.matches || !submitter.matches('[name="checkout"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    normalizeBeforeCheckout(rootPath('/checkout'));
  }, true);

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-ck-open-box-qty="true"]')) return;
    clampInput(input);
    scheduleNormalize();
  }, true);

  document.addEventListener('keydown', function (event) {
    var input = event.target;
    if (event.key !== 'Enter' || !input || !input.matches || !input.matches('[data-ck-open-box-qty="true"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    clampInput(input);
    scheduleNormalize();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest && event.target.closest('form');
    if (!isOpenBoxForm(form)) return;
    form.querySelectorAll('input[name="quantity"], input.js-qty__num').forEach(clampInput);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-ck-open-box-qty="true"]')) return;
    clampInput(input);
    scheduleNormalize();
  }, true);

  document.addEventListener('click', function (event) {
    var plus = event.target && event.target.closest && event.target.closest('.js-qty__adjust--plus, .element-quantity-selector__button--plus');
    if (!plus) return;
    var wrapper = plus.closest('.js-qty__wrapper, quantity-selector, .element-quantity-selector');
    var input = wrapper && wrapper.querySelector('[data-ck-open-box-qty="true"]');
    if (!input) return;
    event.preventDefault();
    event.stopPropagation();
    clampInput(input);
  }, true);

  document.addEventListener('product:added', scheduleNormalize);
  document.addEventListener('cart:updated', scheduleNormalize);
  document.addEventListener('product-form:cart:update', scheduleNormalize);
  document.addEventListener('ajaxProduct:added', scheduleNormalize);

  patchFetch();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      clampOpenBoxForms();
      scheduleNormalize();
    });
  } else {
    clampOpenBoxForms();
    scheduleNormalize();
  }
})();
